<template>
    <div class="test-results">
        <h2 class="title">Voorbeeldtest</h2>

        <div class="bar-chart mx-auto my-3">
            <design2021-apprentice-basic-bar-chart-component
                :options="chartOptions"
                :series="series">
            </design2021-apprentice-basic-bar-chart-component>
        </div>

        <div class="test-result-content">
            <p v-if="resultData.yes > resultData.no">Je hebt vooral ja geantwoord.</p>
            <p v-else-if="resultData.no > resultData.yes">Je hebt vooral nee geantwoord.</p>
            <p v-else>Je hebt evenveel ja als nee geantwoord.</p>
        </div>
    </div>
</template>

<script>
import Design2021ApprenticeBasicBarChartComponent from '../../../common/charts/design-2021-apprentice-basic-bar-chart-component.vue';
import { sortResults } from '../../../../helpers/testCenter';

const testKey = 'example-test';

export default {
    components: { Design2021ApprenticeBasicBarChartComponent },
    props: {
        resultData: {
            type: Object,
        },
    },
    data() {
        return {
            series: [
                {
                    data: sortResults(testKey, this.resultData),
                    name: '',
                },
            ],
            chartOptions: {
                chart: {
                    toolbar: {
                        tools: {
                            download: false,
                        },
                    },
                },
                plotOptions: {
                    bar: {
                        barHeight: '100%',
                        distributed: true,
                        columnWidth: '50%',
                        dataLabels: {
                            show: false,
                        },
                    },
                },
                colors: ['#007000', '#D2222D'],
                xaxis: {
                    categories: ['Ja', 'Nee'],
                    labels: {
                        fontSize: '14px',
                        fontFamily: 'DM Sans',
                    },
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                },
                yaxis: {
                    show: false,
                },
                grid: {
                    show: false,
                },
                dataLabels: {
                    enabled: false,
                },
                tooltip: {
                    enabled: false,
                },
                legend: {
                    show: false,
                },
                states: {
                    active: {
                        filter: {
                            type: 'none',
                        },
                    },
                    hover: {
                        filter: {
                            type: 'none',
                        },
                    },
                },
            },
        };
    },
};
</script>

<style scoped lang="scss"></style>
